import { Route, Routes } from "react-router-dom";
import { NotFoundPage } from "../pages/erros/NotFoundPage.js";
import { HomePage } from "../pages/home/HomePage.js";
import { NosotrosPage } from "../pages/nosotros/NosotrosPage.js";
import LayoutLanding from "../layouts/LayoutLanding.js";
import { ProductosPage } from "../pages/productos/ProductosPage.js";
import { ServiciosPage } from "../pages/servicios/ServiciosPage.js";
import { ContactenosPage } from "../pages/contactenos/ContactenosPage.js";
import { ProductoDetallePage } from "../pages/producto-detalle/ProductoDetallePage.js";
import { GaleriaPage } from "../pages/galeria/GaleriaPage.js";

const AppRoutes = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={<LayoutLanding />}
            >
                <Route path="" element={<HomePage />} />
                <Route path="/nosotros" element={<NosotrosPage />} />
                <Route path="/productos" element={<ProductosPage />} />
                <Route path="/productos/:id" element={<ProductoDetallePage />} />
                <Route path="/servicios" element={<ServiciosPage />} />
                <Route path="/galeria" element={<GaleriaPage />} />
                <Route path="/donde-encontrarnos" element={<ContactenosPage />} />
            </Route>

            <Route path="/error-page" element={<NotFoundPage />} />
        </Routes>
    )
}
export default AppRoutes;